import {

  createBankAccountApi,

  getAllVehicleNumber,
  getFastagMaster,
  getFuelCardMaster,
  handleKeyDown,
} from "_services";

import {
  CommonInput,
  CommonModal,
  CustomSelect,
} from "components";
import images from "constants/images";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices";
// import {addTransactionsTabs} from 'constants/constant'

const AddAccountingAccount = (props) => {
  let { callBackAddAccount = () => { } } = props;
  const addTransactionsTabs = [
    { id: 1, title: "Cash", value: "cash", img: images.RP_WALLET.default },
    { id: 2, title: "Bank", value: "bank", img: images.BANK_ICON.default },
    {
      id: 3,
      title: "Fuel Card",
      value: "fuel_card",
      img: images.FUELCARD_ICON.default,
    },
    {
      id: 4,
      title: "Other",
      value: "other",
      img: images.OTHER_TRANS_ICON.default,
    },
    {
      id: 5,
      title: "Fastag",
      value: "fastag",
      img: images.FASTAG_ICON.default,
    },
  ];

  const initialFrom = {
    company_id: StorageServices.getCompanyId(),
    holder_name: "",
    number: "",
    ifsc: "",
    bank: "",
    bank_opening_balance: "",
    bank_credit_or_debit: 1,
    bank_prefix: "",
    show_bank_prefix: false,
    vendor_account: false,
  };

  const { masterData } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState(2);
  const [form, setForm] = useState(initialFrom);
  const [formError, setFormError] = useState("");
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);


  // Pass closeModal as a prop to CommonModal

  const changeActiveTab = async (event, value) => {
    event.preventDefault();
    setActiveTab(value);
  };

  const arryOptions = [
    { label: "Arjun", value: "01" },
    { label: "Anvit", value: "02" },
  ];

  useEffect(() => {
    const list = masterData?.bank_list?.map((i) => {
      return {
        label: i?.name,
        value: i?.code,
      };
    });
    setForm({ ...form, bank: list[0].value });
    setBankList(list);

  }, [masterData]);

  const handleSearch = async (ifscCode) => {
    // Fetch bank details from Razorpay IFSC API

    const validateIFSC = (code) => {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      return ifscRegex.test(code.toUpperCase());
    };
    const valid = validateIFSC(ifscCode);


    if (valid) {
      console.log("Valid IFSC code. Proceeding to fetch details...");
      try {
        const res = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
        if (!res.ok) {
          return res
        }
        const data = await res.json();
        return data
      } catch (err) {
        toast.error(err.message);
      }
    }
  }


  const handleOnChange = async (name, value) => {
    const stateObj = { ...form, [name]: value };

    if (name === "show_bank_prefix" && value == false) {
      stateObj.bank_prefix = '';
    }

    if (name === "ifsc" && value.length === 11) {
      console.log("IFSC code entered, fetching bank details...");
      try {
        const bankDetails = await handleSearch(value);

        if (bankDetails && bankDetails.BRANCH) {
          stateObj.branch_name = bankDetails.BRANCH;
          stateObj.branch_code = bankDetails.BANKCODE;
          stateObj.city_name = bankDetails.CITY;
          stateObj.state_name = bankDetails.STATE;
          stateObj.bank = bankDetails.BANK;
          // stateObj.holder_name = bankDetails.BANK;

        } else {

          stateObj.branch_name = "";
          setFormError(prev => ({
            ...prev,
            ifsc: "invalid IFSC code",
          }));
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        stateObj.branch_name = "";
      }
    }
    setForm(stateObj);

    if (!!formError) {
      const validationSchemas = {

        2: errorSchema.bankSchema,

      };
      const validationResult = await utils.checkFormError(
        stateObj,
        validationSchemas[activeTab]
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleOnSubmit = async () => {
    const validationSchemas = {

      2: errorSchema.bankSchema,

    };

    const validationResult = await utils.checkFormError(
      { ...form },
      validationSchemas[activeTab]
    );

    const payloads = {

      2: {
        company_id: form?.company_id,
        name: form?.holder_name,
        number: form?.number,
        ifsc: form?.ifsc,
        bank: form?.bank,
        opening_balance: form?.bank_opening_balance,
        credit_or_debit: form?.bank_credit_or_debit,
        prefix: form?.bank_prefix,
        vendor_account: form?.vendor_account
      },

    };

    const apiCalls = {

      2: createBankAccountApi,

    };

    if (validationResult == true) {
      setLoading(true);
      try {
        const payload = payloads[activeTab];
        const apiCall = apiCalls[activeTab];

        if (!payload || !apiCall) {
          toast?.error("Invalid tab or missing payload");
          return;
        }

        const res = await apiCall(payload);
        if (res?.responseCode === 200) {
          callBackAddAccount()
          props?.closeModal()
          toast?.success(res?.responseMessage ? res?.responseMessage : "Account add successfully");
        } else {
          setLoading(false);
          toast?.error(res?.responseMessage);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
        toast?.error(error?.message || "An unexpected error occurred");
      }
    } else {
      setLoading(false);
      setFormError(validationResult);
    }
  };


  const propsTransAccount = {
    ...props,
    onSubmit: handleOnSubmit,
    isLoadding: loading,
    disabled: loading,
    show: "show"
  };


  return (
    <>
      <CommonModal {...propsTransAccount}>
        <div className="addLr_body">

          <div className="addPr_flBx _addTrns_flx">
            <ul
              className="nav nav-tabs cstNew_tabs _truckSelection"
              id="addParty"
              role="tablist"
            >
              {addTransactionsTabs?.length > 0 ? (
                addTransactionsTabs?.map((item, indx) => (
                  <li className="nav-item" role="presentation" key={indx}>
                    <button
                      id={item?.id}
                      className={
                        "nav-link " + (item?.id === activeTab ? "active" : "")
                      }
                      type="button"
                      aria-selected={item?.id === activeTab}
                      disabled={item?.id !== activeTab}
                    // onClick={(e, val) => changeActiveTab(e, item?.id)}
                    >
                      <img
                        src={item.img}
                        className=""
                      //   onClick={(e) => {
                      //     e.stopPropagation();
                      //     setActiveTab({});
                      //     setFilters((s) => ({ ...s, lorry_type_id: '' }))
                      //   }}
                      />

                      {item?.title}
                    </button>
                  </li>
                ))
              ) : (
                <p className="p-2 mt-3"> Loading... </p>
              )}
            </ul>
          </div>



          {activeTab === 2 && (
            <>
              <div className="_allDflx mt-4">
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Bank Account Name"
                    label="Bank Account Name"
                    name="holder_name"
                    focus={!!formError?.holder_name}
                    error={formError.holder_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.holder_name}
                     maxLength={50}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.123456789012345"
                    label="Account Number"
                    name="number"
                    focus={!!formError?.number}
                    error={formError.number}
                    onChange={({ target: { name, value } }) => {
                      if (/^\d*$/.test(value)) {
                        handleOnChange(name, value);
                        // setPhoneError("");
                      }
                    }}
                    maxLength={20}
                    value={form?.number}

                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.SBIN0000000"
                    label="IFSC Code"
                    name="ifsc"
                    focus={!!formError?.ifsc}
                    error={formError.ifsc}
                    onChange={({ target: { name, value } }) => {
                      const upperLatter = value.toUpperCase();

                      handleOnChange(name, upperLatter)
                    }
                    }
                    value={form?.ifsc}
                    maxLength={11}
                  />
                </div>

                {/* <div>
                  <CustomSelect
                    options={bankList}
                    label="Bank Name"
                    placeholder="Bank Name"
                    name="bank"
                    focus={!!formError?.bank}
                    error={formError.bank}
                    onSelect={(data) => handleOnChange("bank", data?.value)}
                    value={bankList?.find((i) => i?.value == form?.bank)}
                  />
                </div> */}

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="bank_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.bank_opening_balance}
                    error={formError.bank_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.bank_opening_balance}
                    // onKeyDown={handleKeyDown}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="bank_credit_or_debit"
                        checked={i.value == form.bank_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>





                <div className="d-flex gap-4" style={{ fontWeight: 500 }}>
                  Supplier / Vendor Account
                </div>
                <div className="d-flex gap-5">
                  {[
                    { label: "Required", value: true },
                    { label: "Not Required", value: false },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i.label}>
                      <input
                        className="form-check-input"
                        id={i.label}
                        type="radio"
                        name="vendor_account"
                        checked={form.vendor_account === i.value}
                        value={i.value}
                        onChange={({ target }) =>
                          handleOnChange(target.name, target.value === "true")
                        }
                      />
                      <label htmlFor={i.label} className="form-check-label">
                        {i.label}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    className="_addMo_deBtn"
                    onClick={() => handleOnChange("show_bank_prefix", !form?.show_bank_prefix)}
                  >
                    {form?.show_bank_prefix ? "Remove More Details" : "Add More Detail"}
                  </button>
                </div>
                {form?.show_bank_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="bank_prefix"
                      focus={!!formError?.bank_prefix}
                      error={formError.bank_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.bank_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}

        </div>

      </CommonModal>




    </>
  );
};

export default AddAccountingAccount
